"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadSimulatorLabelValue = exports.DefaultRegionValue = exports.ThumbLabelValue = exports.EdgeConnectLabelValue = exports.VideoLabelValue = exports.VideoStandbyLabelValue = exports.KubernetesRoles = exports.KubernetesLabels = void 0;
var KubernetesLabels;
(function (KubernetesLabels) {
    KubernetesLabels["video"] = "video";
    KubernetesLabels["video_standby"] = "video_standby";
    KubernetesLabels["region"] = "region";
    KubernetesLabels["default_region"] = "default_region";
    KubernetesLabels["core"] = "core";
    KubernetesLabels["thumb"] = "thumb";
})(KubernetesLabels || (exports.KubernetesLabels = KubernetesLabels = {}));
var KubernetesRoles;
(function (KubernetesRoles) {
    KubernetesRoles["core"] = "core";
    KubernetesRoles["thumb"] = "thumb";
    KubernetesRoles["video"] = "video";
    KubernetesRoles["video_standby"] = "video_standby";
    KubernetesRoles["edge_connect"] = "edge_connect";
    KubernetesRoles["load_simulator"] = "load_simulator";
})(KubernetesRoles || (exports.KubernetesRoles = KubernetesRoles = {}));
var VideoStandbyLabelValue;
(function (VideoStandbyLabelValue) {
    VideoStandbyLabelValue["standby"] = "standby";
})(VideoStandbyLabelValue || (exports.VideoStandbyLabelValue = VideoStandbyLabelValue = {}));
var VideoLabelValue;
(function (VideoLabelValue) {
    VideoLabelValue["enabled"] = "true";
})(VideoLabelValue || (exports.VideoLabelValue = VideoLabelValue = {}));
var EdgeConnectLabelValue;
(function (EdgeConnectLabelValue) {
    EdgeConnectLabelValue["enabled"] = "true";
})(EdgeConnectLabelValue || (exports.EdgeConnectLabelValue = EdgeConnectLabelValue = {}));
var ThumbLabelValue;
(function (ThumbLabelValue) {
    ThumbLabelValue["enabled"] = "true";
})(ThumbLabelValue || (exports.ThumbLabelValue = ThumbLabelValue = {}));
var DefaultRegionValue;
(function (DefaultRegionValue) {
    DefaultRegionValue["true"] = "true";
})(DefaultRegionValue || (exports.DefaultRegionValue = DefaultRegionValue = {}));
var LoadSimulatorLabelValue;
(function (LoadSimulatorLabelValue) {
    LoadSimulatorLabelValue["enabled"] = "true";
})(LoadSimulatorLabelValue || (exports.LoadSimulatorLabelValue = LoadSimulatorLabelValue = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGFiZWxzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2s4cy9sYWJlbHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsSUFBWSxnQkFPWDtBQVBELFdBQVksZ0JBQWdCO0lBQ3hCLG1DQUFlLENBQUE7SUFDZixtREFBK0IsQ0FBQTtJQUMvQixxQ0FBaUIsQ0FBQTtJQUNqQixxREFBaUMsQ0FBQTtJQUNqQyxpQ0FBYSxDQUFBO0lBQ2IsbUNBQWUsQ0FBQTtBQUNuQixDQUFDLEVBUFcsZ0JBQWdCLGdDQUFoQixnQkFBZ0IsUUFPM0I7QUFFRCxJQUFZLGVBUVg7QUFSRCxXQUFZLGVBQWU7SUFDdkIsZ0NBQWEsQ0FBQTtJQUNiLGtDQUFlLENBQUE7SUFDZixrQ0FBZSxDQUFBO0lBQ2Ysa0RBQStCLENBQUE7SUFDL0IsZ0RBQTZCLENBQUE7SUFFN0Isb0RBQWlDLENBQUE7QUFDckMsQ0FBQyxFQVJXLGVBQWUsK0JBQWYsZUFBZSxRQVExQjtBQUVELElBQVksc0JBRVg7QUFGRCxXQUFZLHNCQUFzQjtJQUM5Qiw2Q0FBbUIsQ0FBQTtBQUN2QixDQUFDLEVBRlcsc0JBQXNCLHNDQUF0QixzQkFBc0IsUUFFakM7QUFFRCxJQUFZLGVBRVg7QUFGRCxXQUFZLGVBQWU7SUFDdkIsbUNBQWdCLENBQUE7QUFDcEIsQ0FBQyxFQUZXLGVBQWUsK0JBQWYsZUFBZSxRQUUxQjtBQUVELElBQVkscUJBRVg7QUFGRCxXQUFZLHFCQUFxQjtJQUM3Qix5Q0FBZ0IsQ0FBQTtBQUNwQixDQUFDLEVBRlcscUJBQXFCLHFDQUFyQixxQkFBcUIsUUFFaEM7QUFFRCxJQUFZLGVBRVg7QUFGRCxXQUFZLGVBQWU7SUFDdkIsbUNBQWdCLENBQUE7QUFDcEIsQ0FBQyxFQUZXLGVBQWUsK0JBQWYsZUFBZSxRQUUxQjtBQUVELElBQVksa0JBRVg7QUFGRCxXQUFZLGtCQUFrQjtJQUMxQixtQ0FBYSxDQUFBO0FBQ2pCLENBQUMsRUFGVyxrQkFBa0Isa0NBQWxCLGtCQUFrQixRQUU3QjtBQUVELElBQVksdUJBRVg7QUFGRCxXQUFZLHVCQUF1QjtJQUMvQiwyQ0FBZ0IsQ0FBQTtBQUNwQixDQUFDLEVBRlcsdUJBQXVCLHVDQUF2Qix1QkFBdUIsUUFFbEMifQ==